import { ICON_TYPES } from '../constants';

export const SliderArrow = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.964 22.995">
      <path
        d="M149.286,34.039l-86.521-.056L53.1,40.453,58,33.51l-5-6.974L62.766,33h86.421l-6.32-11,17.1,11.483L143.477,44.994Z"
        transform="translate(-53 -22)"
      />
    </svg>
  );
};

SliderArrow.iconType = ICON_TYPES.SLIDER_ARROW;
